/* eslint-disable */
import Detalhes from "./Detalhes";
import Editar from "./Editar";
import EditarAplicativo from "./EditarAplicativo";
import EditarComplemento from "./EditarComplemento";
import Importar from "./Importar";
import Index from "./index";
import Listar from "./Listar";
import Novo from "./Novo";
import Performance from "./Performance";

const route = {
  path: "/motoristas",
  name: "motoristas",
  component: Index,
  children: [
    {
      path: "novo",
      name: "motorista-novo",
      component: Novo,
      props: true
    },
    {
      path: "importar",
      name: "motorista-importar",
      component: Importar,
      props: true
    },
    {
      path: "listar",
      name: "motorista-listar",
      component: Listar,
      props: { titulo: "Listar", status: null }
    },
    {
      path: "listar-em-validacao",
      name: "motorista-listar-em-validacao",
      component: Listar,
      props: { titulo: "Listar Aguardando Validacao", status: 3 }
    },
    {
      path: "listar-agendamento-solicitado",
      name: "motorista-listar-agendamento-solicitado",
      component: Listar,
      props: { titulo: "Listar Agendamento Solicitado", status: 4 }
    },
    {
      path: "listar-aguardando-agendamento",
      name: "motorista-listar-aguardando-agendamento",
      component: Listar,
      props: { titulo: "Listar Aguardando Agendamento", status: 5 }
    },
    {
      path: "listar-aguardando-ponto-apoio",
      name: "motorista-listar-aguardando-ponto-apoio",
      component: Listar,
      props: { titulo: "Listar Aguardando Ponto de Apoio", status: 6 }
    },
    {
      path: "listar-aguardando-equipamento",
      name: "motorista-listar-aguardando-equipamento",
      component: Listar,
      props: { titulo: "Listar Aguardando Equipamento", status: 7 }
    },
    {
      path: "listar-agendamento-realizado",
      name: "motorista-listar-agendamento-realizado",
      component: Listar,
      props: { titulo: "Listar Agendamento Realizado", status: 8 }
    },
    {
      path: "listar-ativos",
      name: "motorista-listar-ativos",
      component: Listar,
      props: { titulo: "Listar Ativos", status: 1 }
    },
    {
      path: "listar-reprovados",
      name: "motorista-listar-reprovados",
      component: Listar,
      props: { titulo: "Listar Reprovados", status: 2 }
    },
    {
      path: "listar-excluidos",
      name: "motorista-listar-excluidos",
      component: Listar,
      props: { titulo: "Listar Excluídos", status: 9 }
    },
    {
      path: "listar-outras-pracas",
      name: "motorista-listar-outras-pracas",
      component: Listar,
      props: { titulo: "Listar Outras Praças", status: 10 }
    },
    {
      path: "listar-pendentes",
      name: "motorista-listar-pendentes",
      component: Listar,
      props: { titulo: "Listar Pendentes", status: 11 }
    },
    {
      path: "listar-furto-roubo-avaria",
      name: "motorista-listar-furto-roubo-avaria",
      component: Listar,
      props: { titulo: "Listar Furto, Roubo ou Avaria", status: 12 }
    },
    {
      path: "listar-aguardando-pre-analise",
      name: "motorista-listar-aguardando-pre-analise",
      component: Listar,
      props: { titulo: "Listar Aguardando Pré-análise", status: 13 }
    },
    {
      path: "listar-cadastro-nao-finalizado-pre-aprovado",
      name: "motorista-listar-cadastro-nao-finalizado-pre-aprovado",
      component: Listar,
      props: {
        titulo: "Listar Cadastro não Finalizado - Pré Aprovado",
        status: 14
      }
    },
    {
      path: "listar-serasa",
      name: "motorista-listar-serasa",
      component: Listar,
      props: {
        titulo: "Listar Serasa",
        status: 15
      }
    },
    {
      path: "performance",
      name: "motorista-performance",
      component: Performance,
      props: { titulo: "Performance", status: 11 }
    },
    {
      path: ":id",
      name: "motorista-detalhes",
      component: Detalhes,
      props: true
    },
    { path: ":id/e", name: "motorista-editar", component: Editar, props: true },
    {
      path: ":id/complemento/e",
      name: "motorista-complemento-editar",
      component: EditarComplemento,
      props: true
    },
    {
      path: ":id/aplicativo/:cd_aplicativo/e",
      name: "motorista-aplicativo-editar",
      component: EditarAplicativo,
      props: true
    },
    {
      path: ":id/aplicativo/new",
      name: "motorista-aplicativo-adicionar",
      component: EditarAplicativo,
      props: true
    }
  ],
  meta: { requiresAuth: true }
};

export default route;



// WEBPACK FOOTER //
// ./src/pages/motorista/routes.js